import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=bcb1a75a&scoped=true"
import script from "./goodDetail.vue?vue&type=script&lang=js"
export * from "./goodDetail.vue?vue&type=script&lang=js"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=bcb1a75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb1a75a",
  null
  
)

export default component.exports